import { Box } from '@mui/material';
import { ChatsContainerProps } from './chats-list.interface';

export function ChatsListComponent({ children }: ChatsContainerProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        p: '10px',
      }}
    >
      {children}
    </Box>
  );
}
